"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Review = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const ReviewSource_1 = require("../domain/ReviewSource");
const LocalizedField_1 = require("./LocalizedField");
const ReviewMetaData_1 = require("./ReviewMetaData");
let Review = class Review {
    _id = (0, uuid_1.v4)();
    createdAt;
    customerImage;
    sourceUrl;
    photoUrl;
    targets = [];
    rating;
    source;
    // Text Fields
    customerName;
    title;
    body;
    language;
    customerLocation;
    metaData;
    routeId;
    originLocationId;
    destinationLocationId;
    titleLocalized = new LocalizedField_1.LocalizedField();
    bodyLocalized = new LocalizedField_1.LocalizedField();
};
exports.Review = Review;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : new Date(value))),
    __metadata("design:type", Date)
], Review.prototype, "createdAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "customerImage", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "sourceUrl", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "photoUrl", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], Review.prototype, "targets", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Review.prototype, "rating", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], Review.prototype, "source", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "customerName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "title", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "body", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], Review.prototype, "language", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Review.prototype, "customerLocation", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => ReviewMetaData_1.ReviewMetaData, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ReviewMetaData_1.ReviewMetaData),
    __metadata("design:type", ReviewMetaData_1.ReviewMetaData)
], Review.prototype, "metaData", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], Review.prototype, "routeId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], Review.prototype, "originLocationId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], Review.prototype, "destinationLocationId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], Review.prototype, "titleLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], Review.prototype, "bodyLocalized", void 0);
exports.Review = Review = __decorate([
    (0, type_graphql_1.ObjectType)("Review"),
    (0, typeorm_1.Entity)("reviews")
], Review);
//# sourceMappingURL=Review.js.map